<app-shared-mitigations [threatGroup]="threatGroup" />
